module.exports = __webpack_public_path__ + "img/item7.b44263e4.png";